import { AxiosResponse } from "axios";

import API from "../api";

const ROUTE_NAME = "users";

export enum MfaMedium {
  EMAIL = "EMAIL",
  SMS = "SMS",
}

export interface MfaDelivery {
  medium: MfaMedium;
  destination: string;
  deliveryMedium: MfaMedium;
}

export interface MfaLoginResponse {
  success: true;
  requiresMfa: true;
  mfaSessionId: string;
  availableMethods: MfaMedium[];
  expiresInSeconds: number;
  deliveries: MfaDelivery[];
}

export interface MfaChallengeResponse {
  success: true;
  token: string;
  user: any;
  purpose?: "PASSWORD_RESET";
  passwordResetToken?: string;
}

export interface MfaResendRequest {
  mfaSessionId: string;
  medium?: MfaMedium;
}

const MfaService = {
  async validateMfaCode(
    mfaSessionId: string,
    code: string
  ): Promise<AxiosResponse<MfaChallengeResponse>> {
    return await API.post(`/${ROUTE_NAME}/mfa/challenge`, {
      mfaSessionId,
      code,
    });
  },

  async resendMfaCode(request: MfaResendRequest): Promise<AxiosResponse<MfaLoginResponse>> {
    return await API.post(`/${ROUTE_NAME}/mfa/resend`, request);
  },
};

export default MfaService;
